import { Component, OnInit } from '@angular/core';
import { faTimes, faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { listChanges } from 'angularfire2/database';
import { DataService } from '../data.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  imgList = [];
  max = this.imgList.length;
  selected: number;
  loaded: boolean;
  showLightbox: boolean = false;
  closeHover: boolean = false;

  faTimes = faTimes;
  faTimesCircle = faTimesCircle;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  constructor(private data: DataService) { 
    data.getGalleryDB().subscribe(list => {
      this.imgList = list.map(item => {
        return {
          $key: item.key,
          ...item.payload.val()
        }
      });

      this.max = this.imgList.length;
      this.loaded = true;
    })
  }

  ngOnInit() {
  }

  select(selected:number) {
    // if img name is not numbered, let selected be index of array
    this.selected = selected;
    this.showLightbox = true;
  }

  previous() {
    if(this.selected === 0){
      this.selected = this.max-1;
    }
    else {
      this.selected--;
    }
  }

  next() {
    if(this.selected === this.max-1){
      this.selected = 0;
    }
    else {
      this.selected++;
    }
  }

}
